import styled from 'styled-components';

export const StyledCopyButton = styled.div`
    .button-clicked {
        opacity: 0.5;
    }
    .button {
        opacity: 1;
    }
`;